import { BASE } from './api';
import { clearSession, getSessionToken } from './session';
/**
 * Interceptor global de fetch.
 *
 * Injeta os headers de autenticacao em TODA chamada para a API (`/api/v1`),
 * cobrindo tanto o cliente central (`services/api.js`) quanto os ~68 `fetch()`
 * crus espalhados nos componentes. Instalado UMA vez no `index.js`, antes de
 * renderizar o App.
 *
 * Regra do back (auth_middleware): basta X-API-KEY valida OU Bearer JWT.
 * - X-API-KEY: sempre (autoriza a aplicacao web).
 * - Authorization: Bearer <jwt> se houver token salvo no login.
 *
 * Nao mexe em Content-Type nem no body -> uploads multipart (FormData) seguem
 * intactos.
 */
const API_KEY = process.env.REACT_APP_API_KEY || '';
const API_URL = new URL(BASE, window.location.origin);

const originalFetch = window.fetch.bind(window);

function urlOf(input) {
  if (typeof input === 'string') return input;
  if (typeof Request !== 'undefined' && input instanceof Request) return input.url;
  if (typeof URL !== 'undefined' && input instanceof URL) return input.href;
  return String(input || '');
}

window.fetch = (input, init = {}) => {
  const url = urlOf(input);
  const target = new URL(url, window.location.origin);
  if (target.origin !== API_URL.origin ||
      !(target.pathname === API_URL.pathname || target.pathname.startsWith(`${API_URL.pathname}/`))) {
    return originalFetch(input, init);
  }

  // Preserva headers do init e de um eventual Request passado como input.
  const fromRequest =
    typeof Request !== 'undefined' && input instanceof Request ? input.headers : undefined;
  const headers = new Headers((init && init.headers) || fromRequest);

  if (API_KEY) headers.set('X-API-KEY', API_KEY);
  const token = getSessionToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);

  return originalFetch(input, { ...init, headers }).then(response => {
    if (response.status === 401 && token && token === getSessionToken() &&
        !target.pathname.endsWith('/auth/login')) {
      clearSession();
      window.dispatchEvent(new Event('session-expired'));
    }
    return response;
  });
};
